import { ApolloError } from '@apollo/client';

export type GraphQLErrorExtensionsWithResponse = {
  response?: { status?: number };
};

export const getGraphQLErrorHttpStatusFromExtensions = (extensions: unknown): number | undefined =>
  (extensions as GraphQLErrorExtensionsWithResponse | undefined)?.response?.status;

export const getGraphQLErrorHttpStatus = (error: unknown): number | undefined => {
  if (!(error instanceof ApolloError)) {
    return undefined;
  }

  return getGraphQLErrorHttpStatusFromExtensions(error.graphQLErrors[0]?.extensions);
};
